import { Directive }        from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { matDateFormats }   from '../app.config';

@Directive({
  selector: '[rbYearPicker]',
  standalone: true,
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { dateInput: 'YYYY' },
        display: { ...matDateFormats, dateInput: 'YYYY' },
      },
    },
  ],
})
export class YearPickerDirective {

  constructor() {
  }

}
